var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33720_4399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.0325 4.00621C7.66192 4.00621 8.99509 5.37348 9.00856 7.02789C9.00856 8.6823 7.63499 10.0769 6.00556 10.0633C4.36267 10.0496 3.04297 8.6823 3.04297 7.02789C3.04297 5.35981 4.3896 3.99253 6.0325 4.00621Z",
    fill: "#415FF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 15.3135C0 13.8505 1.21197 12.6063 2.65287 12.62C4.09377 12.62 5.2788 13.8369 5.29227 15.2999C5.30574 16.7492 4.0803 18.0071 2.6394 17.9934C1.1985 17.9797 0 16.7765 0 15.3135Z",
    fill: "#415FF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.9791 25.9237C4.6998 25.8963 3.66289 24.8025 3.70329 23.5173C3.74369 22.2457 4.79406 21.1929 6.03297 21.2202C7.31227 21.2339 8.37611 22.3414 8.33571 23.5993C8.29531 24.9119 7.24494 25.951 5.9791 25.9237Z",
    fill: "#415FF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1668 28.9999C13.0761 28.9999 12.1738 28.0839 12.1738 26.9764C12.1738 25.8689 13.0895 24.9528 14.1668 24.9665C15.2442 24.9665 16.1329 25.8825 16.1464 26.9764C16.1464 28.0702 15.2442 28.9999 14.1668 28.9999Z",
    fill: "#415FF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9565 23.5582C23.9565 24.488 23.2158 25.24 22.3136 25.24C21.4113 25.24 20.6572 24.488 20.6572 23.5719C20.6572 22.6695 21.4113 21.8901 22.3136 21.8765C23.2158 21.8765 23.9699 22.6285 23.9699 23.5582H23.9565Z",
    fill: "#415FF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9995 15.2862C26.9995 16.0109 26.4205 16.6262 25.6933 16.6398C24.9661 16.6535 24.3467 16.0246 24.3467 15.2999C24.3467 14.5752 24.9527 13.96 25.6664 13.96C26.3801 13.96 26.9861 14.5616 26.9995 15.2862Z",
    fill: "#415FF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3 6.02979C22.8387 6.02979 23.2831 6.46731 23.2831 7.0279C23.2831 7.58848 22.8387 8.05336 22.2865 8.05336C21.7479 8.05336 21.3035 7.60216 21.29 7.05524C21.29 6.49466 21.7344 6.04346 22.2865 6.04346L22.3 6.02979Z",
    fill: "#415FF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4221 6.72702C16.2517 6.72702 17.7348 5.22112 17.7348 3.36351C17.7348 1.50589 16.2517 0 14.4221 0C12.5925 0 11.1094 1.50589 11.1094 3.36351C11.1094 5.22112 12.5925 6.72702 14.4221 6.72702Z",
    fill: "#415FF6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33720_4399"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.c73b5b70a6d6fe3b00be4cb8a653c05c.svg";
export { ForwardRef as ReactComponent };